
        function greeting() {
            const h = new Date().getHours();
            if (h < 12) return 'morning';
            if (h < 17) return 'afternoon';
            return 'evening';
        }

export { greeting };
